module.exports = require("vuetify/lib/components/VGrid");